// extracted by mini-css-extract-plugin
export default {"content":"CiuLgKeMSYBy3n7AZIBIZA==","btn":"apXnZQ6BiVgY1dUx35dA-A==","title":"Pq3doI+p+dyhYsw7vsEUqw==","text":"ECrGtz1LQBZZfmvM-k1ZxA==","email":"omj7++On7sx0-vmtW2Ey4w=="};